import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  Badge,
  Button,
  Collapse,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  UncontrolledTooltip,
} from 'reactstrap';
import { ChevronDown, ChevronUp } from 'react-feather';
import useI18n from '../../../hooks/use-i18n';
import { handleToastError, parseHtml } from '../../../helpers';
import reportApi from '../../../api/reportApi';
import { formatHHmmDDMMYYYY } from '../../../helpers/format-time';
import {
  QUESTION_TYPE,
  RESULT_STATUS,
  UNIT_STATUS,
  USER_ROLES,
  SHOW_ANSWERS,
} from '../../../constants/constants';
import DragDropResult from '../../Course/Unit/components/ContentTest/ContentResult/ResultItem/DragDropResult';
import DragDropResultPage from 'modules/Course/Unit/components/ContentTest/ContentResult/ResultItem/DragDropPageResult';
import OrderingResult from '../../Course/Unit/components/ContentTest/ContentResult/ResultItem/OrderingResult';
import MTPchoiceResult from '../../Course/Unit/components/ContentTest/ContentResult/ResultItem/MTPchoiceResult';
import theme from '../../../constants/theme';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import { useUnit } from 'hooks/units/index';
import { Check, X } from 'react-feather';
import stylesCourse from 'styles/Course.module.scss';
import { useViewMode } from 'hooks';
import FillInTheBlankMarking from 'modules/Course/Unit/components/ContentTest/ContentResult/ResultItem/manual-marking/fill-in-blank';
import FreeTextMarking from 'modules/Course/Unit/components/ContentTest/ContentResult/ResultItem/manual-marking/free-text';
import { getUnit } from 'store/units';
import CustomCorrect from 'components/AntdFormInputs/custom-input-correct';
import { Col, Row } from 'antd';
import CustomWrong from 'components/AntdFormInputs/custom-input-wrong';
import ThemeButton from 'components/AntdFormInputs/theme-button';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import MultipleChoiceMarking from 'modules/Course/Unit/components/ContentTest/ContentResult/ResultItem/manual-marking/multiple-choice';
import DragDropMarking from 'modules/Course/Unit/components/ContentTest/ContentResult/ResultItem/manual-marking/drag-drop';
import groupApi from 'api/groupApi';
import OrderingMarking from 'modules/Course/Unit/components/ContentTest/ContentResult/ResultItem/manual-marking/ordering';
import FillInTheGapMarking from 'modules/Course/Unit/components/ContentTest/ContentResult/ResultItem/manual-marking/fill-in-the-gap';
import { showToastSuccess } from '@core/components/toastify/ToastTypes';

const COLOR_STATUS = {
  PENDING: 'warning',
  COMPLETED: 'success',
  FAILED: 'danger',
  RESUBMIT: 'primary',
  RESET: 'primary',
  GRADED: 'success',
  REATTEMPT: 'warning',
};
const ResultContext = createContext({});

const ModalDetail = (props) => {
  const {
    data,
    open,
    toggle,
    isHistory,
    isSubmission,
    assignment,
    showLabelAlways,
    getSubmissions,
  } = props;
  const i18n = useI18n();
  const viewMode = useViewMode();
  const reRenderRef = useRef(null);
  const unitSelected = useSelector(getUnit);
  const config = unitSelected?.config ?? data?.unit?.config ?? data?.config;
  const [result, setResults] = useState(undefined);
  const [showResult, setShowResult] = useState([]);

  const unitConfig =
    typeof data?.unit === 'object' ? data?.unit?.config : data?.config;

  const methods = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: {
      unit: data?.unit,
      user: data?.user,
    },
  });
  const { register, handleSubmit, errors, getValues, setError, clearErrors } =
    methods;

  const showCorrect =
    config?.completion?.showCorrect === SHOW_ANSWERS.ALWAYS
      ? true
      : config?.completion?.showCorrect === SHOW_ANSWERS.PASSED &&
        unitSelected?.status === UNIT_STATUS.COMPLETED
      ? true
      : false;
  const iconsShow = config?.completion?.labels;
  const showCorrectIcon =
    config?.completion?.showCorrect && config?.completion?.preview == 'AFTER'
      ? true
      : false;

  async function getResultTest() {
    try {
      let response;
      if (isSubmission) {
        response = await reportApi.getNewResult(data?._id);
      } else {
        response = await reportApi.getReportResultTest(
          isHistory ? data?.submission : data?._id,
        );
      }
      setResults(response);
    } catch (error) {
      handleToastError(error, i18n);
    }
  }

  const updateQuestion = () => {
    if (isSubmission) {
    }
  };

  const updateTest = async (data) => {
    try {
      await groupApi.unitManualMarking({
        ...data,
        result: showResult,
      });
      showToastSuccess('Instructor reviewed successfully!');
      getSubmissions();
    } catch (e) {
      handleToastError(e);
    } finally {
      toggle();
      setShowResult([]);
    }
  };

  const themeStatus = useSelector(getThemeColor);
  useEffect(() => {
    getResultTest();
  }, []);
  const hasShowActionButton =
    !isHistory &&
    result?.status === 'PENDING' &&
    viewMode !== USER_ROLES.LEARNER;

  const renderAnswer = (result, position) => {
    const hasShowActionButton =
      !isHistory &&
      result?.status === 'PENDING' &&
      viewMode !== USER_ROLES.LEARNER;

    if (result?.type === QUESTION_TYPE.FREETEXT) {
      if (
        unitConfig?.manualMarking?.status &&
        unitConfig?.questionType?.FREETEXT &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div>
            <FreeTextMarking result={result} title="Learner Answer" />
            {result.markingComments && (
              <p
                className="mt-1 mb-0 py-1 px-1"
                style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
              >
                Comment : {result.markingComments}
              </p>
            )}
            {hasShowActionButton && <CorrectAndWrong />}
          </div>
        );
      }

      return (
        <>
          {(viewMode !== USER_ROLES.LEARNER || showCorrect) && (
            <div>
              <span className="view-page-title">Correct answer:</span>
              <div className="whiteSpacePre foo freetext-correct-ans">
                <div
                  className={
                    `${stylesCourse['item-section-normal']}` +
                    ` ${stylesCourse['item-section-enabled']}`
                  }
                  style={{
                    '--labelcolor': iconsShow ? '#19a356' : '#c1c9d4',
                  }}
                >
                  {(viewMode !== USER_ROLES.LEARNER || iconsShow) && (
                    <div
                      className="preview_test_correct_lebalgrade"
                      style={{ float: 'right' }}
                    >
                      Correct
                    </div>
                  )}
                  {result?.config?.answers?.map((dt, index) => (
                    <div className="px-05 py-05">{`${index + 1}. ${
                      dt.words
                    } `}</div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {result?.status !== RESULT_STATUS.NOT_ATTEMPT && (
            <div className="mt-1">
              <span className="view-page-title">
                {' '}
                {viewMode === USER_ROLES.LEARNER
                  ? 'Your Answer'
                  : 'Learner Answer'}
                :
              </span>
              <div className="whiteSpacePre foo freetext-correct-ans">
                <div
                  className={`${
                    result?.dataContent === '' ? 'display-none' : ''
                  }`}
                >
                  <div
                    className={
                      `${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow
                        ? showCorrect
                          ? result?.status === RESULT_STATUS.COMPLETED
                            ? '#19a356'
                            : '#e16969'
                          : '#c1c9d4'
                        : '#c1c9d4',
                    }}
                  >
                    {iconsShow ? (
                      showCorrect ? (
                        <>
                          {result?.status === RESULT_STATUS.COMPLETED ? (
                            <>
                              <div
                                className="preview_test_correct_lebalgrade"
                                style={{ float: 'right' }}
                              >
                                Correct
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className="preview_test_wrong_lebalgrade"
                                style={{ float: 'right' }}
                              >
                                Incorrect
                              </div>
                            </>
                          )}
                        </>
                      ) : null
                    ) : null}
                    <span className="">
                      {parseHtml(
                        result?.dataContent,
                        'px-05 py-05 fill-in-the-blank',
                      )}
                    </span>
                    {/* {(viewMode !== USER_ROLES.LEARNER || iconsShow) && (
                      <>
                        {result?.status === RESULT_STATUS.COMPLETED ? (
                          <>
                            <Check
                              id="success"
                              color={theme.success}
                              className="float-right answer-icon"
                            />
                            <UncontrolledTooltip
                              placement="right"
                              target="success"
                            >
                              This was the correct answer
                            </UncontrolledTooltip>
                          </>
                        ) : (
                          <>
                            <X
                              id="failed"
                              color={theme.danger}
                              className="float-right answer-icon"
                            />
                            <UncontrolledTooltip
                              placement="right"
                              target="failed"
                            >
                              This was the wrong answer
                            </UncontrolledTooltip>
                          </>
                        )}
                      </>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      );
    }
    if (result?.type === QUESTION_TYPE.DRAGDROP) {
      if (
        unitConfig?.manualMarking?.status &&
        unitConfig?.questionType?.DRAGDROP &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="freetext-correct-ans">
            <span className="view-page-title ">Learner Answer: </span>
            <Alert className="mt-1 show">
              <DragDropMarking
                asnwer={result?.resultAnswers}
                question={result?.data}
              />
              {hasShowActionButton && <CorrectAndWrong />}
            </Alert>
            {result.markingComments && (
              <p
                className="mb-0 py-1 px-1"
                style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
              >
                Comment : {result.markingComments}
              </p>
            )}
          </div>
        );
      }

      return (
        <DragDropResultPage
          isModal={true}
          result={result}
          showCorrect={viewMode !== USER_ROLES.LEARNER || showCorrect}
          showYourAnswer={result?.status !== RESULT_STATUS.NOT_ATTEMPT}
          showCorrectIcon={viewMode !== USER_ROLES.LEARNER || showCorrectIcon}
          config={config}
          iconsShow={viewMode !== USER_ROLES.LEARNER || iconsShow}
        />
      );
    }

    if (result?.type === QUESTION_TYPE.ORDERING) {
      if (
        unitConfig?.manualMarking?.status &&
        unitConfig?.questionType?.ORDERING &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="freetext-correct-ans">
            <section className="mb-1">
              <OrderingMarking result={result?.data} />
            </section>

            <span className="view-page-title ">Learner Answer: </span>
            <Alert className="mb-1 mt-05 show">
              <OrderingMarking result={result?.result} />
            </Alert>
            {result.markingComments && (
              <p
                className="mb-0 py-1 px-1"
                style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
              >
                Comment : {result.markingComments}
              </p>
            )}
            {hasShowActionButton && <CorrectAndWrong />}
          </div>
        );
      }
      return (
        <OrderingResult
          isModal={true}
          result={result}
          showCorrect={viewMode !== USER_ROLES.LEARNER || showCorrect}
          showYourAnswer={result?.status !== RESULT_STATUS.NOT_ATTEMPT}
          showCorrectIcon={viewMode !== USER_ROLES.LEARNER || showCorrectIcon}
          config={config}
          iconsShow={viewMode !== USER_ROLES.LEARNER || iconsShow}
        />
      );
    }

    if (result?.type === QUESTION_TYPE.MTC) {
      if (
        unitConfig?.manualMarking?.status &&
        unitConfig?.questionType?.MTC &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="freetext-correct-ans-align custom_alignment_modal_test">
            <div className="">
              <span className="view-page-title">Learner Answer: </span>
            </div>
            <Alert className="mb-1 mt-05 show">
              <MultipleChoiceMarking result={result} />
              {hasShowActionButton && <CorrectAndWrong />}
            </Alert>
            {result.markingComments && (
              <p
                className="mb-0 py-1 px-1"
                style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
              >
                Comment : {result.markingComments}
              </p>
            )}
          </div>
        );
      }
      return (
        <MTPchoiceResult
          result={result}
          showCorrect={viewMode !== USER_ROLES.LEARNER || showCorrect}
          showYourAnswer={result?.status !== RESULT_STATUS.NOT_ATTEMPT}
          showCorrectIcon={viewMode !== USER_ROLES.LEARNER || showCorrectIcon}
          config={config}
          iconsShow={viewMode !== USER_ROLES.LEARNER || iconsShow}
        />
      );
    }

    if (result?.type === QUESTION_TYPE.FILLTHEGAP) {
      if (
        unitConfig?.manualMarking?.status &&
        unitConfig?.questionType?.FILLTHEGAP &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <>
            <span className="view-page-title my-1">Learner Answer:</span>
            <FillInTheGapMarking result={result} />
            {result.markingComments && (
              <p
                className="mt-1 mb-0 py-1 px-1"
                style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
              >
                Comment : {result.markingComments}
              </p>
            )}
            {hasShowActionButton && <CorrectAndWrong />}
          </>
        );
      }

      return (
        <>
          {(viewMode !== USER_ROLES.LEARNER || showCorrect) && (
            <div>
              <span className="view-page-title">Correct Answer: </span>
              <div className="whiteSpacePre foo freetext-correct-ans">
                <div
                  className={
                    `flexRow ${stylesCourse['item-section-normal']}` +
                    ` ${stylesCourse['item-section-enabled']}`
                  }
                  style={{
                    '--labelcolor': iconsShow ? '#19a356' : '#c1c9d4',
                  }}
                >
                  {(viewMode !== USER_ROLES.LEARNER || iconsShow) && (
                    <div
                      className="preview_test_correct_lebalgrade"
                      style={{ marginLeft: 'auto' }}
                    >
                      Correct
                    </div>
                  )}
                  <span className="px-05 py-05 fill-overflow-image w-100">
                    {parseHtml(result?.content, 'w-100')}
                  </span>
                </div>
              </div>
            </div>
          )}
          {result?.status !== RESULT_STATUS.NOT_ATTEMPT && (
            <div className="mt-1">
              <strong className="view-page-title ">
                {' '}
                {viewMode === USER_ROLES.LEARNER
                  ? 'Your Answer'
                  : 'Learner Answer'}
                :
              </strong>
              <div className="whiteSpacePre foo freetext-correct-ans text-word-break">
                <div
                  className={
                    `flexRow ${stylesCourse['item-section-normal']}` +
                    ` ${stylesCourse['item-section-enabled']}`
                  }
                  style={{
                    '--labelcolor': iconsShow
                      ? showCorrect
                        ? result?.status === RESULT_STATUS.COMPLETED
                          ? '#19a356'
                          : '#e16969'
                        : '#c1c9d4'
                      : '#c1c9d4',
                  }}
                >
                  {iconsShow ? (
                    showCorrect ? (
                      <>
                        {result?.status === RESULT_STATUS.COMPLETED ? (
                          <div
                            className="preview_test_correct_lebalgrade"
                            style={{ marginLeft: 'auto' }}
                          >
                            Correct
                          </div>
                        ) : (
                          <div
                            className="preview_test_wrong_lebalgrade"
                            style={{ marginLeft: 'auto' }}
                          >
                            Incorrect
                          </div>
                        )}
                      </>
                    ) : null
                  ) : null}
                  <span className=" px-05 py-05 fill-bank w-100">
                    {parseHtml(
                      result?.modifiedContent,
                      'fill-in-the-blank pr-1  w-100 fill-overflow-image',
                    )}
                  </span>
                </div>

                {/* {(viewMode !== USER_ROLES.LEARNER || iconsShow) && (
                    <div className="icon-width">
                      {result?.status === RESULT_STATUS.COMPLETED ? (
                        <>
                          <Check id="success" color={theme.success} />
                          <UncontrolledTooltip
                            placement="right"
                            target="success"
                          >
                            This was the correct answer
                          </UncontrolledTooltip>
                        </>
                      ) : (
                        <>
                          <X id="failed" color={theme.danger} />
                          <UncontrolledTooltip
                            placement="right"
                            target="failed"
                          >
                            This was the wrong answer
                          </UncontrolledTooltip>
                        </>
                      )}
                    </div>
                  )} */}
              </div>
            </div>
          )}
        </>
      );
    }
    if (result?.type === QUESTION_TYPE.FILLINTHEBLANK) {
      if (
        unitConfig?.manualMarking?.status &&
        unitConfig?.questionType?.FILLINTHEBLANK &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <>
            <span className="view-page-title my-1">Learner Answer:</span>
            <FillInTheBlankMarking result={result} />
            {result.markingComments && (
              <p
                className="mt-1 mb-0 py-1 px-1"
                style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
              >
                Comment : {result.markingComments}
              </p>
            )}
            {hasShowActionButton && <CorrectAndWrong />}
          </>
        );
      }
      return (
        <>
          {(viewMode !== USER_ROLES.LEARNER || showCorrect) && (
            <>
              <div className="whiteSpacePre foo freetext-correct-ans">
                <span className="view-page-title">Correct Answer: </span>
                <div
                  className={
                    `flexRow ${stylesCourse['item-section-normal']}` +
                    ` ${stylesCourse['item-section-enabled']}`
                  }
                  style={{
                    '--labelcolor':
                      viewMode !== USER_ROLES.LEARNER || iconsShow
                        ? '#19a356'
                        : '#c1c9d4',
                  }}
                >
                  {(viewMode !== USER_ROLES.LEARNER || iconsShow) && (
                    <div
                      className="preview_test_correct_lebalgrade"
                      style={{ marginLeft: 'auto' }}
                    >
                      Correct
                    </div>
                  )}
                  <span className="fill-bank-span w-100 px-05 py-05 fill-overflow-image">
                    {parseHtml(
                      result?.content,
                      'fill-in-the-blank fill-blank fill-overflow-image',
                    )}
                  </span>
                </div>
              </div>
            </>
          )}
          {result?.status !== RESULT_STATUS.NOT_ATTEMPT && (
            <div className="mt-1">
              <strong className="view-page-title">
                {' '}
                {viewMode === USER_ROLES.LEARNER
                  ? 'Your Answer'
                  : 'Learner Answer'}
                :
              </strong>
              <div className="whiteSpacePre foo freetext-correct-ans">
                <div
                  className={
                    `flexRow ${stylesCourse['item-section-normal']}` +
                    ` ${stylesCourse['item-section-enabled']}`
                  }
                  style={{
                    '--labelcolor': iconsShow
                      ? showCorrect
                        ? result?.status === RESULT_STATUS.COMPLETED
                          ? '#19a356'
                          : '#e16969'
                        : '#c1c9d4'
                      : '#c1c9d4',
                  }}
                >
                  {iconsShow ? (
                    showCorrect ? (
                      <>
                        {result?.status === RESULT_STATUS.COMPLETED ? (
                          <>
                            <div
                              className="preview_test_correct_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Correct
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className="preview_test_wrong_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Incorrect
                            </div>
                          </>
                        )}
                      </>
                    ) : null
                  ) : null}
                  <span className="fill-bank-span fill-in-the-blank w-100  px-05 py-05 fill-overflow-image">
                    {parseHtml(result?.modifiedContent)}
                  </span>
                </div>
              </div>
            </div>
          )}
        </>
      );
    }
  };
  const renderQuestion = (item, position) => {
    if (
      item?.type === QUESTION_TYPE.FREETEXT ||
      item?.type === QUESTION_TYPE.MTC ||
      item?.type === QUESTION_TYPE.DRAGDROP ||
      item?.type === QUESTION_TYPE.ORDERING
    ) {
      return (
        <div className="d-flex align-items-center">
          {item?.order + ')'}
          {parseHtml(
            item?.content,
            'fill-in-the-blank fill-overflow-image manual-customtagp customconten_elecment w-100 ml-50',
          )}
        </div>
      );
    }
    if (item?.type === QUESTION_TYPE.FILLTHEGAP) {
      return (
        <>
          <div className="freetext-correct-ans">
            <div className="customconten_elecment d-flex align-items-center fill-overflow-image">
              {item?.order + ')'}{' '}
              {parseHtml(item?.contentHTML, 'ml-50 w-100 manual-customtagp')}{' '}
            </div>
          </div>
        </>
      );
    }
    if (item?.type === QUESTION_TYPE.FILLINTHEBLANK) {
      return (
        <>
          <div className="freetext-correct-ans">
            <div className="d-flex align-items-center customconten_elecment">
              {item?.order + ')'}{' '}
              {parseHtml(
                item?.contentHTML,
                'fill-in-the-blank ml-50 fill-overflow-image w-100 manual-customtagp',
              )}
            </div>
          </div>
        </>
      );
    }
  };

  //require count
  let requiredQuiz = 0;

  result?.result?.forEach((quiz) => {
    if (
      quiz?.status === RESULT_STATUS.PENDING &&
      unitConfig?.manualMarking?.status &&
      unitConfig?.manualMarking?.questionTypes?.includes(quiz?.type)
    ) {
      requiredQuiz++;
    }
  });

  console.log({ assignment, config });
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const displayFeedback =
    result?.feedback ||
    result?.submission?.feedback ||
    result?.submission?.aiReply?.feedback ||
    data?.feedback ||
    data?.submission?.feedback;

  const displayPublishGrade =
    result?.publishGrade ||
    result?.submission?.publishGrade ||
    data?.publishGrade ||
    data?.submission?.publishGrade;

  console.log({ displayFeedback, displayPublishGrade });

  return (
    <>
      <Modal
        isOpen={open}
        toggle={toggle}
        className="modal-dialog-top"
        size="lg"
      >
        <ModalHeader toggle={toggle}>
          <strong className="font-medium-4">{data?.title}</strong>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(updateTest)}>
            <div style={{ fontSize: 15, fontWeight: 600 }}>
              <strong className="view-page-title">
                {data?.user?.fullName}
              </strong>{' '}
              <span className=" ">
                Submitted: {formatHHmmDDMMYYYY(data?.submission?.updatedAt)}
              </span>{' '}
              |{' '}
              <Badge color={`light-${COLOR_STATUS[data?.status]}`}>
                {data?.status === 'FAILED'
                  ? 'NOT PASSED'
                  : data?.status === RESULT_STATUS.PENDING &&
                    unitConfig?.manualMarking?.status
                  ? 'Pending for Review'
                  : data?.status}{' '}
                {data?.status === RESULT_STATUS.PENDING &&
                unitConfig?.manualMarking?.status
                  ? null
                  : `${data?.points?.toFixed(0)}%`}
              </Badge>{' '}
              {viewMode !== USER_ROLES.LEARNER && (
                <>
                  | <span>Total: {result?.result?.length}</span> |{' '}
                  <span>
                    Correct:{' '}
                    {
                      result?.result.filter(
                        (item) => item?.status === RESULT_STATUS.COMPLETED,
                      ).length
                    }
                  </span>{' '}
                  |{' '}
                  <span>
                    Incorrect:{' '}
                    {
                      result?.result.filter(
                        (item) => item?.status === RESULT_STATUS.FAILED,
                      ).length
                    }
                  </span>
                  {displayPublishGrade &&
                    displayPublishGrade !== 'undefined' && (
                      <>
                        {' '}
                        | <span>Grade: {displayPublishGrade}</span>
                      </>
                    )}{' '}
                  | <span>Require: {requiredQuiz}</span>
                </>
              )}
            </div>

            {displayFeedback && displayFeedback !== 'undefined' && (
              <div className="mt-1">
                <div
                  className="d-flex align-items-center cursor-pointer font-weight-bold"
                  style={{
                    userSelect: 'none',
                    color: '#5e5873',
                    fontSize: '13px',
                    gap: '6px',
                  }}
                  onClick={() => setFeedbackOpen(!feedbackOpen)}
                >
                  <span>Feedback</span>
                  {feedbackOpen ? (
                    <ChevronUp size={15} />
                  ) : (
                    <ChevronDown size={15} />
                  )}
                </div>
                <Collapse isOpen={feedbackOpen}>
                  <div
                    className="p-2 rounded mt-1 border"
                    style={{
                      backgroundColor: '#f8f9fa',
                      color: '#6e6b7b',
                      fontSize: '13px',
                      lineHeight: '1.6',
                    }}
                  >
                    {displayFeedback}
                  </div>
                </Collapse>
              </div>
            )}

            <hr />
            {result === undefined ? (
              <div className="m-2 flexRow justify-content-center">
                <Spinner style={{ color: `${themeStatus}` }} />
              </div>
            ) : (
              <div ref={reRenderRef}>
                {result?.result?.map((item, index) => (
                  <div
                    key={index}
                    id={
                      item?.type === QUESTION_TYPE.DRAGDROP
                        ? QUESTION_TYPE.DRAGDROP
                        : null
                    }
                  >
                    {index !== 0 ? <hr /> : null}
                    {(showLabelAlways ||
                      assignment?.config?.completion?.labels ||
                      config?.completion?.labels) && (
                      <div className="d-flex align-items-center mb-1">
                        {item?.status === RESULT_STATUS.COMPLETED ? (
                          <Badge color="success">Correct</Badge>
                        ) : item?.status === RESULT_STATUS.FAILED ? (
                          <Badge color="danger">Incorrect</Badge>
                        ) : item?.status === RESULT_STATUS.PENDING &&
                          unitConfig?.manualMarking?.status &&
                          unitConfig?.manualMarking?.questionTypes?.includes(
                            item?.type,
                          ) ? (
                          <Badge color="light-warning">
                            Instructor Review Required
                          </Badge>
                        ) : item?.status === RESULT_STATUS.NOT_ATTEMPT ? (
                          <Badge>Not Answered</Badge>
                        ) : null}
                      </div>
                    )}

                    <ResultContext.Provider
                      value={{
                        position: index,
                        data: item,
                        setState: setShowResult,
                        state: showResult,
                        getValues: getValues,
                        setError: setError,
                        clearErrors: clearErrors,
                      }}
                    >
                      {item?.content && (
                        <div className="my-50">
                          <div className="d-flex justify-content-between mb-1">
                            <strong className="view-page-title d-flex d-lex align-items-center">
                              Question:
                            </strong>

                            {item?.isManualMarking ? (
                              <div
                                className="d-flex align-items-center align-items-center"
                                style={{ gap: '10px' }}
                              >
                                {item?.status === 'PENDING' ? (
                                  <FormGroup className="mb-0">
                                    <Input
                                      placeholder="Weight"
                                      onWheel={(e) => e.target.blur()}
                                      type="number"
                                      disabled={showResult
                                        .map((element) => element?.question)
                                        .includes(item?._id)}
                                      name={`questions.${index}.weight`}
                                      className="mini-input-width-7"
                                      innerRef={register()}
                                      onChangeCapture={() => {
                                        clearErrors(
                                          `questions.${index}.weight`,
                                        );
                                      }}
                                      invalid={
                                        !!errors?.questions?.[index]?.weight
                                      }
                                    />
                                    <FormFeedback>
                                      {
                                        errors?.questions?.[index]?.weight
                                          ?.message
                                      }
                                    </FormFeedback>
                                  </FormGroup>
                                ) : (
                                  <div></div>
                                )}
                                {item?.status === 'PENDING' ? (
                                  <p className="mb-0 custom-marktest-weight">{`${item?.weight}`}</p>
                                ) : (
                                  <p className="mb-0 custom-marktest-weight">{`${
                                    item?.userWeight || 0
                                  }/${item?.weight}`}</p>
                                )}
                                {/* <p className="mb-0 custom-marktest-weight">{`${item?.userWeight}/${item?.weight}`}</p> */}
                              </div>
                            ) : (
                              <p className="mb-0 custom-marktest-weight">{`${
                                item?.status === UNIT_STATUS.FAILED
                                  ? 0
                                  : item?.status === UNIT_STATUS.COMPLETED
                                  ? item?.weight
                                  : item?.userWeight ?? 0
                              }/${item?.weight}`}</p>
                            )}
                          </div>
                          {/* {parseHtml(
                        item?.type === QUESTION_TYPE.FREETEXT ||
                          item?.type === QUESTION_TYPE.MTC ||
                          item?.type === QUESTION_TYPE.DRAGDROP ||
                          item?.type === QUESTION_TYPE.ORDERING
                          ? `<div>${index + 1}) ${item?.content}</div>`
                          : `<div>${index + 1}) ${item?.contentHTML}</div>`,
                        'fill-in-the-blank  fill-overflow-image',
                      )} */}
                          {renderQuestion(item, index)}
                        </div>
                      )}
                      {item?.status !== RESULT_STATUS.NOT_ATTEMPT && (
                        <div className={`my-2 custom_alignment_modal_test `}>
                          {renderAnswer(item, index)}
                        </div>
                      )}
                    </ResultContext.Provider>
                  </div>
                ))}
              </div>
            )}

            <hr />
            <Row className="mx-0" justify="end">
              {hasShowActionButton && (
                <ThemeButton
                  type="submit"
                  padding="7px 18px"
                  className="rounded-pill mr-05"
                  disabled={showResult?.length !== requiredQuiz}
                >
                  Submit
                </ThemeButton>
              )}
              <Button
                type="button"
                color="secondary"
                className="round"
                onClick={toggle}
                outline
              >
                Close
              </Button>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter className="px-05 py-05"></ModalFooter>
      </Modal>
    </>
  );
};

export default ModalDetail;

const CorrectAndWrong = () => {
  const i18n = useI18n();
  const { position, data, setState, state, getValues, setError, clearErrors } =
    useContext(ResultContext);

  const [checkboxState, setCheckboxState] = useState({
    wrong: false,
    correct: false,
  });
  const [markingComments, setMarkingComments] = useState('');
  //correct check validation
  const handleManualWeight = () => {
    const weight = getValues(`questions.${position}.weight`);
    if (!weight) {
      setError(`questions.${position}.weight`, {
        type: 'required',
        message: 'Required',
        shouldFocus: true,
      });
      return false;
    }
    if (weight > data?.weight) {
      setError(`questions.${position}.weight`, {
        type: 'max',
        message: 'Not greater value',
        shouldFocus: true,
      });
      return false;
    }
    return true;
  };
  //wrong check validation
  const handleManualWrong = () => {
    const weight = getValues(`questions.${position}.weight`);
    if (weight) {
      setError(`questions.${position}.weight`, {
        type: 'required',
        message: 'No need weight',
        shouldFocus: true,
      });
      return false;
    }
    return true;
  };

  const appendOrModify = (checked, questionStatus, comments) => {
    const weight = getValues(`questions.${position}.weight`);
    let questionsType = {
      question: data?._id,
      status: questionStatus,
      weight: Number(weight),
      markingComments: comments,
    };
    if (checked) {
      const newState = [...state];
      let hasQuiz = newState.findIndex((quiz) => quiz?.question === data?._id);
      if (hasQuiz !== -1) {
        newState;
        newState[hasQuiz] = {
          ...questionsType,
        };
        setState(newState);
      } else {
        newState.push(questionsType);
        setState([...newState]);
      }
    } else {
      const updateStatus = state?.filter((dt) => dt?.question !== data?._id);
      setState(updateStatus);
    }
    clearErrors(`questions.${position}.weight`);
  };

  return (
    <Row justify="" className="mx-0 mt-1">
      <Col span={12}>
        <FormGroup className="mb-0">
          <Input
            type="textarea"
            placeholder="Comments"
            defaultValue={data?.markingComments}
            value={markingComments}
            onChange={(e) => setMarkingComments(e.target.value)}
            disabled={state
              .map((element) => element?.question)
              .includes(data?._id)}
          />
        </FormGroup>
      </Col>
      <Col span={12}>
        <Row justify="end" className="mx-0 mt-1">
          <Row className="ml-0 mr-1" align="middle">
            <CustomCorrect
              checked={checkboxState.correct}
              disabled={checkboxState?.wrong}
              onChange={({ target: { checked } }) => {
                if (handleManualWeight()) {
                  appendOrModify(
                    checked,
                    UNIT_STATUS.COMPLETED,
                    markingComments,
                  );
                  setCheckboxState({ correct: checked, wrong: false });
                }
              }}
            />
            <span className="view-page-title ml-1">Correct</span>
          </Row>
          <Row className="mx-0" align="middle">
            <CustomWrong
              checked={checkboxState.wrong}
              disabled={checkboxState?.correct}
              onChange={({ target: { checked } }) => {
                if (handleManualWrong()) {
                  appendOrModify(checked, UNIT_STATUS.FAILED, markingComments);
                  setCheckboxState({ correct: false, wrong: checked });
                }
              }}
            />
            <span className="view-page-title ml-1">Wrong</span>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};
